module.exports = __webpack_public_path__ + "img/maimeng-bg.be26e4ec.jpg";